import React, { PropTypes, Component } from 'react';
import { NitroHeading, NitroParagraph } from 'nitro-components';
import styled from 'styled-components';

import PortalNotificationSetting from './PortalNotificationSetting';

import Breakpoint from '../../../../utils/breakpoints';

import {PORTAL_SETTINGS_HEADING, PORTAL_SETTINGS_INTRO} from '../content';

const MainContainer = styled.div`

`;

const PortalSettingContainer = styled.div`
	margin: 30px 0px;
`;

class PortalNotifcation extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { data, saveInfo } = this.props;
		return (
			<MainContainer>
				<Breakpoint name="desktop">
					<NitroHeading
						label={PORTAL_SETTINGS_HEADING}
						size="2"
						header
						noMargin
						variant="secondary"
					/>
				</Breakpoint>
				<NitroParagraph
					size="2"
					noMargin
				>{PORTAL_SETTINGS_INTRO}</NitroParagraph>
				<PortalSettingContainer>
					{data &&
						data.map((item, index) => {
							return (
								<PortalNotificationSetting
									key={index}
									data={item}
									savePortalEditInfo={saveInfo}
								/>
							);
						})}
				</PortalSettingContainer>
			</MainContainer>
		);
	}
}

PortalNotifcation.propTypes = {
	data: PropTypes.array,
	saveInfo: PropTypes.func
};

export default PortalNotifcation;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/PortalNotification.js